// apps/web/src/admin/ExportPdfButton.tsx
import { useState } from 'react';

export function ExportPdfButton({ onExport, label = 'Export to PDF' }: {
  onExport: () => Promise<void> | void;
  label?: string;
}) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function handle() {
    setBusy(true);
    setErr(null);
    try {
      await onExport();
    } catch (e: any) {
      setErr(e?.message ?? String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <span className="inline-flex items-center gap-2">
      {err ? <span className="text-red-600 text-xs">{err}</span> : null}
      <button className="btn btn-ghost" disabled={busy} onClick={() => void handle()}>
        {busy ? 'Generating…' : label}
      </button>
    </span>
  );
}
